/**
 * primaryMenu
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
import './_primary-menu.scss';

// Module template
import './_primary-menu.twig';

import hoverintent from 'hoverintent/index.js';
import transit from 'jquery.transit/jquery.transit.js';

export const name = 'primaryMenu';

export const defaults = {
  breakpoint: 1024,
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { primaryMenu = {} }) {
  // Find our component within the DOM
  const $primaryMenu = $('.primary-menu', $context);
  // Bail if component does not exist
  if (!$primaryMenu.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = Object.assign(defaults, $primaryMenu);

  // Debounced routine which checks browser width and acts on primary menu.
  const mobileMenu = debounce(function(e) {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    // Check if the mobile menu should apply.
    if (viewportWidth < settings.breakpoint) {
      applyAccordion($primaryMenu);
    }
    else {
      removeAccordion($primaryMenu);
    }
  }, 250);
  window.addEventListener('resize', mobileMenu, false);
  // Also trigger the check on first load.
  mobileMenu();
}

/**
 * Applies the accordion functionality to the primary menu.
 *
 * $primaryMenu Object
 *   A jQuery object for the primary menu.
 */
const applyAccordion = function($primaryMenu) {
  if (!$primaryMenu.hasClass('accordion-is-active')) {
    $primaryMenu.addClass('accordion-is-active');

    // Get rid of hoverintent.
    $primaryMenu.children('ul').children('li').each(function(index, item) {
      // Unbind hoverIntent.
      $(this).unbind('mouseenter').unbind('mouseleave');
      $(this).removeProp('hoverIntent_t');
      $(this).removeProp('hoverIntent_s');
      // Unbind the focus events.
      $(this).unbind('focusin', 'focusout');

      $(this).find('.menu-dropdown-wrapper').each(function () {
        $(this).css('height', '');
        $(this).css('border-bottom', '');
        $(this).css('z-index', '');
        $(this).css('opacity', '');
      });

    });

    $primaryMenu.unbind('mouseenter').unbind('mouseleave');
    $primaryMenu.removeProp('hoverIntent_t');
    $primaryMenu.removeProp('hoverIntent_s');

    const allPanels = $('.menu-dropdown-wrapper', $primaryMenu);
    allPanels.hide();
    $('> ul > li:not(:last-child) > a', $primaryMenu).on('click', function(event) {
      event.preventDefault();
      allPanels.slideUp();
      const $thisListItem = $(this).parent();
      // Remove the class from other panel headings.
      $('> ul > li', $primaryMenu).not($thisListItem).removeClass('dropdown-is-active');
      // Toggle the class on this one.
      $thisListItem.toggleClass('dropdown-is-active');
      // If the class is present then slide down the contents.
      if ($thisListItem.hasClass('dropdown-is-active')) {
        $thisListItem.find('.menu-dropdown-wrapper').slideDown();
      }
    });
    $('> ul > li:not(:last-child) > a', $primaryMenu).on('mousedown', function(event) {
      allPanels.removeData('mouseDown');
      $(this).data('mouseDown', true);
      return false;
    });
    $('> ul > li:not(:last-child) > a', $primaryMenu).on('focusin', function() {
      if (!$(this).data('mouseDown')) {
        $(this).click();
      }
    });
  }
};

/**
 * Removes the accordion functionality from the primary menu.
 *
 * $primaryMenu Object
 *   A jQuery object for the primary menu.
 */
const removeAccordion = function($primaryMenu) {
  if ($primaryMenu.hasClass('accordion-is-active')) {
    $primaryMenu.removeClass('accordion-is-active');
    $('> ul > li:not(:last-child) > a', $primaryMenu).off('click');
    $('.menu-dropdown-wrapper', $primaryMenu).show();
    $('.primary-menu').show();
  }

  const $overlayElement = $('.bg-overlay');
  const $header = $('.masthead');

  let openItems = [];
  let submenuHeight = 0;

  // Turn off clicks for all top menu items apart from Donate.
  $('> ul > li:not(:last-child) > a', $primaryMenu).on('click', function(event) {
    event.preventDefault();
  });

  // The desktop menu is shown so use hoverintent.
  $primaryMenu.children('ul').children('li').each(function(index, item) {
    const thisHeight = $(this).find('ul.container').height() + 6;
    if (thisHeight > submenuHeight) {
      submenuHeight = thisHeight;
    }

    hoverintent($(this)[0],
      function() {
        // Hover function. Should only do something if the mobile
        // menu is not being shown.
        const $listItem = $(this);
        $listItem.addClass('item-is-open');
        $(this).find('.menu-dropdown-wrapper').each(function() {
          $(this).height(submenuHeight - 6);
          $(this).css('border-bottom', '6px solid #44841A');
          $(this).css('z-index', 20);
          $(this).transition({ opacity: 1 }, 300, 'in', function() {
            $header.addClass('menu-is-open');
          });
        });
        // Add this item to the openItems stack.
        openItems.push($(this)[0]);
      },
      function() {
        // Not hovering function.
        $(this).removeClass('item-is-open');
        $(this).find('.menu-dropdown-wrapper').each(function() {
          $(this).css('border-bottom', '');
          $(this).transition({ opacity: 0 }, 300, 'out', function() {
            $(this).height(0);
            $(this).css('z-index', 1);
          });
        });
        const current = $(this)[0];
        // When closing, remove the currently closing item from the
        // openItems array. This is then used to determine whether
        // there are any open menu items.
        openItems = openItems.filter(function(value) {
          return value !== current;
        });
        if (!openItems.length) {
          $header.removeClass('menu-is-open');
        }
      }).options({
        timeout: 300,
        sensitivity: 7,
        interval: 50,
      });

    // Add the focus functionality.
    $(this).focusin(function () {
      $(this).find('.menu-dropdown-wrapper').each(function () {
        $(this).height(submenuHeight - 6);
        $(this).css('border-bottom', '6px solid #44841A');
        $(this).css('opacity', 1);
      });
    });
    $(this).focusout(function () {
      $(this).removeClass('item-is-open');
      $(this).find('.menu-dropdown-wrapper').each(function () {
        $(this).height(0);
        $(this).css('opacity', 0);
      });
    });

  });

  $primaryMenu.find('ul li ul.container').height(submenuHeight);

  // Add the hoverintent on the primary menu for the overlay.
  hoverintent($primaryMenu[0],
    function() {
      $overlayElement.css('height', '100vh');
      $overlayElement.transition({opacity: 0.4}, 300, 'in', function () {
        $(this).addClass('is-visible');
      });
    },
    function() {
      $overlayElement.transition({opacity: 0}, 300, 'out', function () {
        $(this).removeClass('is-visible');
        $(this).css('height', 0);
      });
    }).options({
      timeout: 300,
      interval: 500,
    });
};

// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
const restArguments = function(func, startIndex) {
  startIndex = startIndex == null ? func.length - 1 : +startIndex;
  return function() {
    var length = Math.max(arguments.length - startIndex, 0),
      rest = Array(length),
      index = 0;
    for (; index < length; index++) {
      rest[index] = arguments[index + startIndex];
    }
    switch (startIndex) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, arguments[0], rest);
      case 2: return func.call(this, arguments[0], arguments[1], rest);
    }
    var args = Array(startIndex + 1);
    for (index = 0; index < startIndex; index++) {
      args[index] = arguments[index];
    }
    args[startIndex] = rest;
    return func.apply(this, args);
  };
};

// Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
const delay = restArguments(function(func, wait, args) {
  return setTimeout(function() {
    return func.apply(null, args);
  }, wait);
});

/**
 * Debounce function from underscore library.
 */
const debounce = function(func, wait, immediate) {
  var timeout, result;

  var later = function(context, args) {
    timeout = null;
    if (args) result = func.apply(context, args);
  };

  var debounced = restArguments(function(args) {
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(later, wait);
      if (callNow) result = func.apply(this, args);
    } else {
      timeout = delay(later, wait, this, args);
    }

    return result;
  });

  debounced.cancel = function() {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
};

export default enable;
